export default __webpack_public_path__ + "static/media/Background_00074.85320b1d.png";